import api from '../../utils/api';

export const updateUserRoles = (userId: number, roleIds: Array<number>) =>
  api.put({
    url: `/user/${userId}/roles`,
    variables: {
      roleIds,
    },
  });
